export default __webpack_public_path__ + "static/grey-desserto-d6846ba4965228dae265c04e9c8a26af.png";